import Skeleton from '@mui/material/Skeleton'
import classNames from 'classnames'
import React from 'react'
import styles from './Breadcrumbs.module.scss'
import Link from '../Link'

interface Item {
  id: number
  link: string
  anchor: string
  asLink?: boolean
}

type Props = {
  items?: Item[]
  classes?: {
    root?: string
  }
}

const Breadcrumbs: React.FC<Props> = props => {
  const { classes } = props
  if (!props.items) {
    return (
      <Skeleton variant="text" classes={{ root: classNames(styles['breadcrumbs'], classes?.root!) }} sx={{ minWidth: '300px' }}>
        <li className={styles['breadcrumbs__item']}>&nbsp;</li>
      </Skeleton>
    )
  }

  return props.items.length < 1 ? (
    <div className={classNames(styles['breadcrumbs'], classes?.root!)} />
  ) : (
    <ul className={classNames(styles['breadcrumbs'], classes?.root!)}>
      {props.items.map(item => {
        return (
          <li key={item.id} className={styles['breadcrumbs__item']}>
            {item.asLink === false ? <span>{item.anchor}</span> : <Link to={item.link}>{item.anchor}</Link>}
          </li>
        )
      })}
    </ul>
  )
}

export default Breadcrumbs
